import Box from "@mui/material/Box";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Bloc "Livre / Cours terminé" — remplace l'ancien toggle Oui/Non
// objet : "livre" | "cours" | "general"
function TermineBlock({ termine, saving, onChange, objet = "livre" }) {
  const isGeneral = objet === "general";
  const nom = objet === "livre" ? "Livre" : "Cours";

  let border = termine ? "1.5px solid #4caf50" : "1.5px solid #e0e0e0";
  if (isGeneral) border = `3px solid ${termine ? "#4caf50" : "#fb8c00"}`;

  return (
    <Box sx={{
      p: 3, borderRadius: 2, border, mt: 2,
      backgroundColor: termine ? "#f1f8e9" : "#fff",
      transition: "all 0.2s",
    }}>
      {isGeneral && (
        <MDTypography variant="caption" fontWeight="bold" sx={{
          display: "block", mb: 1.5, textTransform: "uppercase",
          fontSize: 12, letterSpacing: "0.06em", color: "#9e9e9e",
        }}>
          Cours général / Conférence terminé ?
        </MDTypography>
      )}
      <MDBox display="flex" alignItems="center" justifyContent="space-between" gap={2} flexWrap="wrap">
        <MDBox display="flex" alignItems="center" gap={2}>
          {termine
            ? <CheckCircleIcon sx={{ fontSize: 28, color: "#4caf50" }} />
            : <HourglassEmptyIcon sx={{ fontSize: 28, color: "#9e9e9e" }} />}
          <MDBox>
            <MDTypography sx={{
              fontSize: 16, fontWeight: 600, lineHeight: 1.3,
              color: termine ? "#2e7d32" : "#616161",
            }}>
              {nom} {termine ? "terminé" : "en cours"}
            </MDTypography>
            <MDTypography sx={{ fontSize: 13, color: termine ? "#81c784" : "#bdbdbd" }}>
              {termine ? "Cliquez pour rouvrir" : "Marquer comme terminé"}
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDButton variant="outlined" size="small" disabled={saving}
          onClick={() => onChange(!termine)}
          sx={termine ? {
            borderColor: "#e57373", color: "#e57373", borderRadius: "8px",
            "&:hover": { borderColor: "#e53935", color: "#e53935", background: "#ffebee" },
          } : {
            borderColor: "#4caf50", color: "#2e7d32", borderRadius: "8px",
            "&:hover": { borderColor: "#2e7d32", background: "#f1f8e9" },
          }}>
          {termine ? "Rouvrir" : "Terminer ce cours"}
        </MDButton>
      </MDBox>
    </Box>
  );
}

export default TermineBlock;
